import { render, staticRenderFns } from "./EmailSettingsTemplate.vue?vue&type=template&id=1aef64ed"
import script from "./EmailSettingsTemplate.vue?vue&type=script&lang=ts"
export * from "./EmailSettingsTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aef64ed')) {
      api.createRecord('1aef64ed', component.options)
    } else {
      api.reload('1aef64ed', component.options)
    }
    module.hot.accept("./EmailSettingsTemplate.vue?vue&type=template&id=1aef64ed", function () {
      api.rerender('1aef64ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/EmailSettingsTemplate/EmailSettingsTemplate.vue"
export default component.exports